import type { NodeParameters } from '../../../types/node-properties';

/**
 * Default parameter values for MS SQL Server node
 */
export const defaults: NodeParameters = {
  // Credential
  credential: '',

  // Operation
  operation: 'executeQuery',

  // Execute Query
  query: '',
  parameters: {},

  // Table operations
  table: '',
  sourceArray: '',

  // Update operation
  matchColumn: 'id',

  // Delete operation
  deleteColumn: '',
  deleteCondition: 'equals',
  deleteValue: '',

  // Drop table
  ifExists: true,

  // Create table
  dropIfExists: false,
  insertData: true,

  // Settings
  queryTimeout: 120,
};

export default defaults;
